<header class="content-header-container">
  <h1 class="page-title">{{ text }}</h1>
  <app-arrow-link-right
    *ngIf="showEdit"
    text="Edit"
    (handleClick)="onEdit()"
  ></app-arrow-link-right>
</header>
